
import './polyfills/required';
import lazyload from './lazyload.js';
import civicCookie from './civic-cookie';
import observer from './observer';
import alertDismiss from './alert-dismiss';
import meganav from './navigation.js';

lazyload();
civicCookie();
observer();
alertDismiss();
meganav();

document.querySelectorAll('a[target="_blank"]').forEach((link) => {
  const notice = document.createElement('span');
  notice.textContent = 'Opens in new tab';
  notice.classList.add('sr-only');
  link.appendChild(notice);
});
